import { useState, useCallback } from 'react';
import { debounce } from 'lodash';
import useResizeObserver from 'use-resize-observer';
export const useDebouncedResizeObserver = (wait, opts, debounceOpts) => {
    const [size, setSize] = useState({ width: undefined, height: undefined });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onResize = useCallback(debounce((receivedSize) => {
        var _a;
        if (!receivedSize.width || !receivedSize.height) {
            return;
        }
        setSize(receivedSize);
        (_a = opts === null || opts === void 0 ? void 0 : opts.onResize) === null || _a === void 0 ? void 0 : _a.call(opts, receivedSize);
    }, wait, Object.assign({ leading: false }, debounceOpts)), [wait]);
    const { ref } = useResizeObserver(Object.assign(Object.assign({}, opts), { onResize }));
    return Object.assign({ ref }, size);
};
